import React from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';
import Upload from 'Components/Upload/index';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { getUser } from 'Utils/storage';
const UploadFilePopup = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter">
            <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {"Upload File"} 
            </div>
            {<div className='mb-10'>
                <div>
                    <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                        Enter the Remarks
                    </div>
                    <Input name="seekerRemarks" placeholder={'Remarks'} value={props.value} onChange={(e) => props.onChange(e)} />
                </div>
                <div className='mt-10'>
                    <Upload onChange={props.onUploadLoiDocs}>
                        <button className="ht-25 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" >Upload File</button>
                    </Upload>
                    {(props.loi_docs || []).map(doc => (
                        <div className='mt-5'>
                            <a onClick={() => props.downloadUploadedFile(doc.name)}>{doc.name}</a>
                            <DeleteIcon className={'wt-18 ht-18 ml-20 curP'} onClick={() => props.deleteDoc()}></DeleteIcon>
                        </div>
                    ))}
                </div>
            </div>}
            {!! props.mandatory_error_message && <div className="error-color fs-14 fSemibold op-7 mt-10">Please fill remarks</div>}
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
                {<button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onSave}>Save</button>}
            </div>
        </div>
    </Overlay>
);
export default UploadFilePopup;